import http from '@/http/fetch'

//全部角色
export const getRoleList = () => http.get('/governApi/role/queryRoleList')
//全部菜单
export const getAuthorityTable = () => http.get('/governApi/function/queryFunctionList')
//添加权限
export const addRoleFunction = (parms) => http.post('/governApi/rolefunction/addRoleFunction',parms)
//登录用户权限
export const queryFunctionByUserId = (parms) => http.get('/governApi/rolefunction/queryFunctionByUserId',parms)
//角色权限回显
export const queryFunctionByRoleId = (parms) => http.get('/governApi//rolefunction/queryFunctionByRoleId',parms)


